import { ButtonBase } from "@mui/material";
import { COLOR_BLACK } from "helpers/colors";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import usePseudoStyle from "helpers/usePseudoStyle";
import React from "react";

export const DROPDOWN_FONT_SIZE = "0.75rem";
export const DROPDOWN_ITEM_PADDING = "6px 12px";

// A row in the game overview team and player dropdown menus, so both lists look the same.
export default function DropdownItem({ selected = false, onClick, children }) {
  const { className } = usePseudoStyle(selected ? {} : { ":hover": "background-color: #f5f5f5 !important;" });

  return (
    <ButtonBase
      className={className}
      onClick={onClick}
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: 8,
        boxSizing: "border-box",
        minHeight: 44, // the height of a player row with its number avatar
        padding: DROPDOWN_ITEM_PADDING,
        fontFamily: FONT_FAMILY_GRAPHIK,
        fontSize: DROPDOWN_FONT_SIZE,
        fontWeight: 400,
        letterSpacing: "0.01em",
        color: COLOR_BLACK,
        textAlign: "left",
        whiteSpace: "nowrap",
        ...(selected && {
          fontWeight: 500,
          backgroundColor: "rgb(254,246,247)",
          color: "#e0137a",
        }),
      }}
    >
      {children}
    </ButtonBase>
  );
}
